export default {
  "content": "<g clip-path=\"url(#clip0_30_1348)\" fill=\"#7B61FF\"><path d=\"M13 6v7.5h-2V6h2zM12 18.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.515 3.515c4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97-4.686 4.687-12.284 4.687-16.97 0-4.687-4.686-4.687-12.284 0-16.97zM19.07 4.929c-3.905-3.905-10.237-3.905-14.142 0-3.905 3.905-3.905 10.237 0 14.142 3.905 3.906 10.237 3.906 14.142 0 3.906-3.905 3.906-10.237 0-14.142z\"/></g><defs><clipPath id=\"clip0_30_1348\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};